import * as React from "react";
import classnames from "classnames";
import { Icon } from "@grandvisionhq/icons";
/* empty css                      */
const SimpleBreadcrumb = ({ className, title, href, ...rest }) => {
  const classes = classnames("store-simple-breadcrumb-stores-v2", className);
  const children = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Icon, { name: "chevron-left" }), title);
  return href ? /* @__PURE__ */ React.createElement("a", { ...rest, href, className: classes }, children) : /* @__PURE__ */ React.createElement("p", { ...rest, className: classes }, children);
};
export {
  SimpleBreadcrumb as default
};
//# sourceMappingURL=SimpleBreadcrumb.js.map
